import React from "react";
import classes from "./RepeatIcon.scss";
import classNames from "classnames";
import { Trans } from "react-i18next";

import { Tooltip } from "@toddle-edu/ds-web";
import { LinkSimpleHorizontalOutlined } from "@toddle-edu/ds-icons";

const RepeatIcon = ({ isAssessment = false, source }) => {
  return (
    <Tooltip
      tooltip={
        <div className={classes.tooltipContainer}>
          <Trans
            i18nKey={`${
              source == "COURSE_FLOW" ? "course" : "unitPlan"
            }:this_item_is_connected_view`}
          />
        </div>
      }
    >
      <div
        className={classNames(classes.iconContainer, {
          [classes.assessmentIconContainer]: isAssessment,
        })}
      >
        <LinkSimpleHorizontalOutlined size="xxxx-small" variant="on" />
      </div>
    </Tooltip>
  );
};

export default RepeatIcon;
